// ============================================================================
// computeField — derive `computed` field values from other form fields
// ============================================================================
// Current grammar (keep deliberately small):
//
//   "<date_field> + <days_field>"   →  add N days to a yyyy-mm-dd date
//
// Returns null when inputs are missing/invalid. Extend the parser only when a
// new shape lands in a form_spec — speculative grammar gets crufty.

import type { FormValues } from 'api/types/formSpec.types';

const DATE_PLUS_DAYS = /^\s*([A-Za-z_][A-Za-z0-9_]*)\s*\+\s*([A-Za-z_][A-Za-z0-9_]*)\s*$/;

export function evalComputed(expr: string, values: FormValues): unknown {
  const m = expr.match(DATE_PLUS_DAYS);
  if (m) {
    const dateRaw = values[m[1]];
    const daysRaw = values[m[2]];
    if (typeof dateRaw !== 'string' || !dateRaw) return null;
    const days = Number(daysRaw);
    if (!Number.isFinite(days)) return null;
    const d = new Date(`${dateRaw}T00:00:00`);
    if (Number.isNaN(d.getTime())) return null;
    d.setDate(d.getDate() + days);
    return d.toISOString().slice(0, 10);
  }
  // Unknown expression form — return null so the field stays empty rather than
  // showing stale junk. A console warning helps spot typos in form_spec.
  // eslint-disable-next-line no-console
  console.warn(`[computeField] unrecognised expression: "${expr}"`);
  return null;
}
